import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Line } from 'react-chartjs-2';
import { colorPalette } from '../../utils/color-utils';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export default function ChartDayTelesaleCalling({ data, title }: any) {
    const labels = data.map((item: any) => item.day)

    // Make sure data is properly formatted
    data.forEach((item: any) => {
        if (!item.breakdown) {
            item.breakdown = { SUCCESS: 0, FAIL: 0 };
        }

        if (item.breakdown.SUCCESS === undefined) {
            item.breakdown.SUCCESS = 0;
        }

        if (item.breakdown.FAIL === undefined) {
            item.breakdown.FAIL = 0;
        }
    });


    const datasets = [
        {
            label: 'Tổng cộng',
            data: data.map((item: any) => item.total_calls),
            borderColor: colorPalette[0],
            backgroundColor: colorPalette[0],
            pointBackgroundColor: colorPalette[0],
            pointBorderColor: colorPalette[0],
            borderWidth: 4,
            datalabels: {
                color: colorPalette[0],
                formatter: (value: any) => value === 0 ? '' : value,
            },
        },
        {
            label: 'Gia hạn',
            data: data.map((item: any) => item.breakdown?.SUCCESS || 0),
            borderColor: colorPalette[2],
            backgroundColor: colorPalette[2],
            pointBackgroundColor: colorPalette[2],
            pointBorderColor: colorPalette[2],
            borderWidth: 4,
            hidden: true,
            datalabels: {
                color: colorPalette[2],
                formatter: (value: any) => value === 0 ? '' : value,
            },
        },
        {
            label: 'Thất bại',
            data: data.map((item: any) => item.breakdown?.FAIL || 0),
            borderColor: colorPalette[1],
            backgroundColor: colorPalette[1],
            pointBackgroundColor: colorPalette[1],
            pointBorderColor: colorPalette[1],
            borderWidth: 4,
            hidden: true,
            datalabels: {
                color: colorPalette[1],
                formatter: (value: any) => value === 0 ? '' : value,
            },
        },
    ]

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
                font: {
                    size: 16,
                },
                padding: {
                    bottom: 24,
                },
            },
            datalabels: {
                display: true,
                offset: 4,
                padding: {
                    top: 4
                },
                backgroundColor: function (context: any) {
                    return context.dataset.hidden || context.raw === 0 ? null : 'rgba(255, 255, 255, 0.7)';
                },
                borderRadius: 4,
                font: {
                    size: 12,
                    weight: 'bold',
                },
                anchor: 'end',
                align: 'top',
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    } as any

    return (
        <Line data={{ labels, datasets }} options={options} />
    )
}
